import { MacroStatus } from "./macroNodeManager";

export enum ActionTypeBackend {
  START_A_FLOW = "startAflow",
  MULTI_ACTION = "multiAction",
  TRIGGER = "trigger",
  MESSAGE = "message",
}

export interface MacroConfig {
    [key: string]: any; // dynamic node keys e.g. N1, N2
}

export interface Macro {
    index?: number;
    macroId: string;
    description: string;
    visibleToTeams: number[];
    visibleToAgents: number[];
    status: MacroStatus;
    isResponseIncluded: boolean;
    isAgentReviewRequired: boolean;
    config: MacroConfig;
    stickyNotes?: any;
    storeId: string;
    createdAt: number;
    channels: string[];
    title: string;
    updatedAt: number;
}

export interface GetMacrosRequest {
  storeId: string;
  macroId?: string;
}

export interface CreateOrUpdateMacroRequest {
  storeId: string;
  macroId?: string;
  updatedBy?: number;
  title?: string;
  description?: string;
  channels?: string[]; 
  visibleToTeams?: number[];
  visibleToAgents?: number[];
  isResponseIncluded?: boolean;
  isAgentReviewRequired?: boolean;
  status?: MacroStatus;
  config?: any;
  stickyNotes?: any;
  index?: number;
}

export interface GetMacrosResponse {
    status: number;
    success: boolean;
    data: {
        data: {
            macros: Macro[];
            hasNext: boolean;
            hasPrevious: boolean;
        }
    };
}

export interface MacroNodeProps {
    newNodeData: { [key: string]: string | number };
    storeId: string;
    flowId: string;
    type: string;
    forceFetch?: boolean;
    setIndex: (idx: number) => void;
    index: number;
    stickyIndex: number;
    setStickyIndex: (idx: number) => void;
    getNodeId: () => string;

}


/**
 * Generic backend config for other node types not covered by specific payloads
 */
export interface GenericBackendConfig {
    type: string;
    subType?: string;
}

export enum FrontendNodeType {
    MESSAGE = "Message",
    ACTION = "Action",
    STICKY_NOTES = "Sticky notes",
}

export enum MacroNodeCategory {
    JOURNEY = "Journey",
    ADVANCED = "Advanced",
    STICKY_NOTES = "Sticky notes",
}

//Enums for NodeAction State in macros
export enum MacroNodeActionType {
    NODE = "node",
    EDGE = "edge",
    EDGES = "edges",
}

export enum MacroNodeActionVerb {
    CREATED = "created",
    HOVER = "hover",
    DELETE = "delete",
}
